var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6584 0.484339C15.9231 0.749102 15.9231 1.17837 15.6584 1.44313L6.20672 10.8948C5.88873 11.2128 5.37316 11.2128 5.05517 10.8948L1.05551 6.89511C0.790743 6.63035 0.790743 6.20108 1.05551 5.93632C1.32027 5.67156 1.74954 5.67156 2.0143 5.93632L5.63094 9.55297L14.6996 0.484339C14.9643 0.219576 15.3936 0.219576 15.6584 0.484339Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.0c103c63230e36a32a9184686c36bd22.svg";
export { ForwardRef as ReactComponent };